import { Media } from '../media/Media'
import { Artwork } from '../artwork/Artwork'
import { Artist } from '@/services/artist/Artist'
import { arrUniqueByKeys } from "@aeq/arr";

export class Gallery {
  id: string = ''
  name: string = ''
  about: string = ''
  slug: string = ''
  description: string = ''
  phone: string = ''
  email: string = ''
  street: string = ''
  post_code: string = ''
  city: string = ''
  web_page: string = ''
  web_page_label: string = ''
  exhibition_artist: string = ''
  exhibition_name: string = ''
  exhibition_description: string = ''
  physical_from: string | null = null
  physical_till: string | null = null
  exhibition_from: string | null = null
  exhibition_till: string | null = null
  media: Media | null = null
  artworks: Artwork[] = []

  constructor (data: Partial<Gallery> = {}) {
    Object.assign(this, data)
  }

  // TODO return only unique artist
  get artists (): Artist[] {
    return this.artworks
      .map(aw => aw.artist)
      .filter((a): a is Artist => !!a )
  }

  get uniqueArtists(): Artist[] {
    return arrUniqueByKeys(this.artists, ['id']);
  }


}
